import { render, staticRenderFns } from "./SelectTipoIntegracao.vue?vue&type=template&id=4e6554fc&scoped=true&"
import script from "./SelectTipoIntegracao.vue?vue&type=script&lang=ts&"
export * from "./SelectTipoIntegracao.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6554fc",
  null
  
)

export default component.exports